var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { t } from 'i18next';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Config } from '../../../../api/config';
import { CheckRepeatUrl, saveDeclinedCustomerComplaintsUrl } from '../../../../api/url';
import RoadTestNew from '../../../../components/templates/roadTest/roadTestNew';
import RoadTest from '../../../../components/templates/roadTest/roadTest';
import TranslateToJobComponent from '../../../../components/templates/translateToJob/translateToJobComponent';
import TranslateToJobMessage from '../../../../components/templates/translateToJob/translateToJobMessage';
import VehicleDetailsViewJobs from '../../../../components/templates/viewJobs/vehicleDetails.viewJobs';
import { EFinalInspectorModuleSection, EModuleSection, ESABoxParent, isModuleConfig, isShowCapacitorMap, LOCAL_STORAGE_KEYS, Module } from '../../../../constants';
import { setIsTaskDetailsDataUpdated, setUpdatedModuleSectionByChannel, showLoader, showNotification } from '../../../../redux/commonSlice';
import { createAPI, getByIdAPI, getListAPI, setState } from '../../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { getLocalStorageItem } from '../../../../utils/storageHelper';
import useAnalyticsEventTracker from '../../../../utils/useAnalyticsEventTracker';
import { getCustomerVoiceSectionAttributes, GoogleAnlyticsErrorLog } from '../../../../utils/utils';
var RoadTestComponent = function (props) {
    var trackButtonClick = useAnalyticsEventTracker("RoadTestComponent");
    var parentModuleDocumentId = props.parentModuleDocumentId, parentModuleName = props.parentModuleName, callApIStatus = props.callApIStatus, getCustomerComplaintListUrl = props.getCustomerComplaintListUrl, saveTranslateToJobItemUrl = props.saveTranslateToJobItemUrl, apiRequestParam = props.apiRequestParam, apiRequestPayload = props.apiRequestPayload, _a = props.isSaveButton, isSaveButton = _a === void 0 ? true : _a, _b = props.isDisabled, isDisabled = _b === void 0 ? false : _b, SystemName = props.SystemName;
    var dispatch = useAppDispatch();
    var _c = useState(false), isTranslateToJobClicked = _c[0], setTranslateToJobChecked = _c[1];
    var _d = useState(false), openViewJobs = _d[0], setOpenViewJobs = _d[1];
    var _e = useState(), listValue = _e[0], setListValue = _e[1];
    var _f = useState(""), StartDateTime = _f[0], setStartDateTime = _f[1];
    var _g = useState(false), isTestStarted = _g[0], setIsTestStarted = _g[1];
    var _h = useState(''), customerVoiceId = _h[0], setCustomerVoiceId = _h[1];
    var _j = useState([]), pathCordinates = _j[0], setPathCordinates = _j[1];
    var _k = useState(), timeDuration = _k[0], setTimeDuration = _k[1];
    var _l = useState(), distance = _l[0], setDistance = _l[1];
    var _m = useState(false), isTestDone = _m[0], setIsTestDone = _m[1];
    var _o = useState(false), openSARemarkPopup = _o[0], setOpenSARemarkPopup = _o[1];
    var _p = useSelector(function (state) { return state.common; }), updatedModuleSectionByChannel = _p.updatedModuleSectionByChannel, customerVoiceSectionDetails = _p.customerVoiceSectionDetails;
    var _q = useAppSelector(function (state) { return state.crud; }), FIChecklistItemChange = _q.FIChecklistItemChange, FinalInspectionChecklistCount = _q.FinalInspectionChecklistCount, getModuleHeaderCount = _q.getModuleHeaderCount, customerDetailsTrnalsteToJob = _q.customerDetailsTrnalsteToJob, ModuleDetailsGetById = _q.ModuleDetailsGetById, repeatAlertConfiguration = _q.repeatAlertConfiguration;
    var _r = useState(""), roadTestId = _r[0], setRoadTestId = _r[1];
    var selectedDesignation = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    useEffect(function () {
        initiate();
    }, [callApIStatus]);
    var initiate = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!callApIStatus) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all([getRoadTest()])];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var getRoadTest = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, _response$payload$dat, _response$payload$dat2, _response$payload$dat3, _response$payload$dat4, _response$payload$dat5, startdate, enddate, duration, sortedList_1, updatedFIChecklistChangeDetails, updatedItem, updatedFICounts, updatedCountItem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!parentModuleDocumentId) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL + apiRequestParam, "/RoadTest"),
                            request: apiRequestPayload
                        }))];
                case 1:
                    response = _a.sent();
                    if (response.payload.success && response.payload.data && response.payload.data.RoadTest && response.payload.data.RoadTest.length > 0) {
                        setIsTestDone(true);
                        setRoadTestId((_response$payload$dat = response.payload.data.RoadTest[0]) === null || _response$payload$dat === void 0 ? void 0 : _response$payload$dat.RoadTestId);
                        setPathCordinates((_response$payload$dat2 = response.payload.data.RoadTest[0]) === null || _response$payload$dat2 === void 0 ? void 0 : _response$payload$dat2.GeoCoordination);
                        setDistance((_response$payload$dat3 = response.payload.data.RoadTest[0]) === null || _response$payload$dat3 === void 0 ? void 0 : _response$payload$dat3.Distance);
                        startdate = moment((_response$payload$dat4 = response.payload.data.RoadTest[0]) === null || _response$payload$dat4 === void 0 ? void 0 : _response$payload$dat4.StartDateTime);
                        enddate = moment((_response$payload$dat5 = response.payload.data.RoadTest[0]) === null || _response$payload$dat5 === void 0 ? void 0 : _response$payload$dat5.EndDateTime);
                        duration = moment.duration(enddate.diff(startdate)).asSeconds();
                        setTimeDuration(duration);
                        sortedList_1 = [];
                        if (selectedDesignation.Name === "FinalInspector") {
                            updatedFIChecklistChangeDetails = _objectSpread({}, FIChecklistItemChange);
                            updatedItem = _objectSpread({}, updatedFIChecklistChangeDetails.roadTest);
                            updatedItem.isItemRejected = false;
                            updatedItem.isSaveClick = true;
                            updatedFIChecklistChangeDetails.roadTest = updatedItem;
                            dispatch(setState({
                                key: "FIChecklistItemChange",
                                value: updatedFIChecklistChangeDetails
                            }));
                            updatedModuleSectionByChannel.map(function (item) {
                                var data = cloneDeep(item);
                                if (item.Key == EFinalInspectorModuleSection.RoadTest) {
                                    if (Module === isModuleConfig.Product) {
                                        data.SectionAttributes[0].MANDATORY = true;
                                        data.SectionAttributes[0].MANDATORYDefaultValue = true;
                                    }
                                }
                                sortedList_1.push(data);
                            });
                            dispatch(setUpdatedModuleSectionByChannel(sortedList_1));
                            updatedFICounts = _objectSpread({}, FinalInspectionChecklistCount);
                            updatedCountItem = _objectSpread({}, updatedFICounts.roadTest);
                            updatedCountItem.approvedCount = 1;
                            updatedCountItem.totalCount = 1;
                            updatedCountItem.rejectedCount = 0;
                            updatedFICounts.roadTest = updatedCountItem;
                            dispatch(setState({
                                key: "FinalInspectionChecklistCount",
                                value: updatedFICounts
                            }));
                        }
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleStartRoadTest = function (startLatLong) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setIsTestStarted(true);
            setStartDateTime(new Date().toISOString());
            dispatch(setIsTaskDetailsDataUpdated(true));
            return [2 /*return*/];
        });
    }); };
    var handleEndRoadTest = function (duration, distance, path) { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload, requestBody, response, _response$payload$val, sortedList_2, updatedFIChecklistChangeDetails, updatedItem, updatedFICounts, updatedCountItem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsTestStarted(false);
                    trackButtonClick("ButtonClickEvent", "RoadTest_Saved", undefined);
                    requestBody = _objectSpread({
                        GeoCoordination: path,
                        StartDateTime: StartDateTime,
                        EndDateTime: new Date().toISOString(),
                        Distance: distance
                    }, apiRequestPayload);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: "".concat(Config.baseURL + apiRequestParam, "/UpsertRoadTest"),
                            request: requestBody
                        }))];
                case 1:
                    response = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    setIsTestDone(true);
                    if ((_response$payload = response.payload) !== null && _response$payload !== void 0 && (_response$payload = _response$payload.value) !== null && _response$payload !== void 0 && _response$payload.success) {
                        setRoadTestId(response === null || response === void 0 || (_response$payload$val = response.payload.value) === null || _response$payload$val === void 0 || (_response$payload$val = _response$payload$val.data) === null || _response$payload$val === void 0 ? void 0 : _response$payload$val.RoadTestId);
                        sortedList_2 = [];
                        if (selectedDesignation.Name === "FinalInspector") {
                            updatedFIChecklistChangeDetails = _objectSpread({}, FIChecklistItemChange);
                            updatedItem = _objectSpread({}, updatedFIChecklistChangeDetails.roadTest);
                            updatedItem.isItemRejected = false;
                            updatedItem.isSaveClick = true;
                            updatedFIChecklistChangeDetails.roadTest = updatedItem;
                            dispatch(setState({
                                key: "FIChecklistItemChange",
                                value: updatedFIChecklistChangeDetails
                            }));
                            updatedModuleSectionByChannel.map(function (item) {
                                var data = cloneDeep(item);
                                if (item.Key == EFinalInspectorModuleSection.RoadTest) {
                                    if (Module === isModuleConfig.Product) {
                                        data.SectionAttributes[0].MANDATORY = true;
                                        data.SectionAttributes[0].MANDATORYDefaultValue = true;
                                    }
                                }
                                sortedList_2.push(data);
                            });
                            updatedFICounts = _objectSpread({}, FinalInspectionChecklistCount);
                            updatedCountItem = _objectSpread({}, updatedFICounts.roadTest);
                            updatedCountItem.approvedCount = 1;
                            updatedCountItem.totalCount = 1;
                            updatedCountItem.rejectedCount = 0;
                            updatedFICounts.roadTest = updatedCountItem;
                            dispatch(setState({
                                key: "FinalInspectionChecklistCount",
                                value: updatedFICounts
                            }));
                        }
                        else {
                            updatedModuleSectionByChannel.map(function (item) {
                                var data = cloneDeep(item);
                                if (item.Key == EModuleSection.RoadTest) {
                                    if (Module === isModuleConfig.Product) {
                                        data.SectionAttributes[0].MANDATORY = true;
                                        data.SectionAttributes[0].MANDATORYDefaultValue = true;
                                    }
                                }
                                sortedList_2.push(data);
                            });
                        }
                        dispatch(setUpdatedModuleSectionByChannel(sortedList_2));
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("Road test saved successfully."),
                            type: "success"
                        }));
                        // buttonClickSpan.end();
                        // pageLoadSpan.end();
                        // transaction.end();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCloseTranslateToJoBitem = function () {
        setTranslateToJobChecked(function (prev) { return !prev; });
    };
    var handleCloseViewJobs = function () {
        setOpenViewJobs(function (prev) { return !prev; });
    };
    var handleSaveTrnalateToJob = function (listValue, declinedComplaints) { return __awaiter(void 0, void 0, void 0, function () {
        var _getCustomerVoiceSect, _ModuleDetailsGetById3, _response$payload2, _response$payload3, filterArrayChecked, filterArrayUnCheckedAlreadySaved, savedArray_1, finalArray_1, transformedArray_1, checkComment, profileData, updatedDeclinedJobItems, declinedRequestBodyArray_1, declinedRequestBody, request, response, declinedResult, _repeatAlertConfigura, _repeatAlertConfigura2, _repeatAlertConfigura3, _ModuleDetailsGetById4, _ModuleDetailsGetById5, _ModuleDetailsGetById6, repeatBody, checkRepeatResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!listValue) return [3 /*break*/, 6];
                    filterArrayChecked = listValue.flatMap(function (obj) { return obj.data ? obj.data.filter(function (item) { return item.isCheckBoxClicked; }) : []; });
                    filterArrayUnCheckedAlreadySaved = listValue.flatMap(function (obj) { return obj.data ? obj.data.filter(function (item) { return !item.isCheckBoxClicked && item.isAlreadySaved; }) : []; });
                    savedArray_1 = (customerDetailsTrnalsteToJob === null || customerDetailsTrnalsteToJob === void 0 ? void 0 : customerDetailsTrnalsteToJob.data) || [];
                    finalArray_1 = [];
                    filterArrayChecked.map(function (checkedItem) {
                        var matchitem = savedArray_1.find(function (savedItem) { return savedItem.ComplaintId === checkedItem.ComplaintId; });
                        if (matchitem) {
                            finalArray_1.push(checkedItem);
                            savedArray_1 = savedArray_1.filter(function (savedItem) { return savedItem.ComplaintId !== matchitem.ComplaintId; });
                        }
                        else {
                            finalArray_1.push(checkedItem);
                        }
                    });
                    filterArrayUnCheckedAlreadySaved.map(function (uncheckedItem) {
                        var matchItem = savedArray_1.find(function (savedItem) { return savedItem.ComplaintId === uncheckedItem.ComplaintId; });
                        if (matchItem) {
                            savedArray_1 = savedArray_1.filter(function (savedItem) { return savedItem.ComplaintId !== matchItem.ComplaintId; });
                        }
                    });
                    savedArray_1.map(function (savedItem) {
                        finalArray_1.push(savedItem);
                    });
                    transformedArray_1 = finalArray_1.map(function (obj) {
                        var _obj$Comments;
                        var ImageAttachmentsArray = [];
                        if (obj !== null && obj !== void 0 && obj.images && obj.images.length > 0) {
                            obj.images.map(function (image) {
                                ImageAttachmentsArray.push({
                                    AttachmentId: image.attachmentId,
                                    MediaType: 1,
                                    SystemName: "CustomerVoiceToJobItem"
                                });
                            });
                        }
                        if (obj.audioAttachmentId) {
                            ImageAttachmentsArray.push({
                                AttachmentId: obj.audioAttachmentId,
                                MediaType: 2,
                                SystemName: "CustomerVoiceToJobItem"
                            });
                        }
                        var ComplaintAssociations = [];
                        if (obj.ComplaintChildAssociation) {
                            var _obj$ComplaintChildAs, _obj$ComplaintChildAs2;
                            (_obj$ComplaintChildAs = obj.ComplaintChildAssociation) === null || _obj$ComplaintChildAs === void 0 || (_obj$ComplaintChildAs = _obj$ComplaintChildAs.Part) === null || _obj$ComplaintChildAs === void 0 || _obj$ComplaintChildAs.map(function (partItem) {
                                var _ModuleDetailsGetById;
                                ComplaintAssociations.push({
                                    Quantity: partItem.Quantity,
                                    SystemName: "Product",
                                    ChildId: partItem.ChildId,
                                    ServiceGroupId: obj.ComplaintId,
                                    ServiceTypeId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById === void 0 ? void 0 : _ModuleDetailsGetById.RepairTypeId,
                                    ServiceDetailType: 4,
                                    ParentSystemName: apiRequestParam,
                                    Price: null
                                });
                            });
                            (_obj$ComplaintChildAs2 = obj.ComplaintChildAssociation) === null || _obj$ComplaintChildAs2 === void 0 || (_obj$ComplaintChildAs2 = _obj$ComplaintChildAs2.Labour) === null || _obj$ComplaintChildAs2 === void 0 || _obj$ComplaintChildAs2.map(function (labourItem) {
                                var _ModuleDetailsGetById2;
                                ComplaintAssociations.push({
                                    Quantity: labourItem.Quantity,
                                    SystemName: "Labour",
                                    ChildId: labourItem.ChildId,
                                    ServiceGroupId: obj.ComplaintId,
                                    ServiceTypeId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById2 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById2 === void 0 ? void 0 : _ModuleDetailsGetById2.RepairTypeId,
                                    ServiceDetailType: 4,
                                    ParentSystemName: apiRequestParam,
                                    Price: null
                                });
                            });
                        }
                        return {
                            SystemName: obj.SystemName ? obj.SystemName : "RoadTest",
                            ComplaintGroupAssociationId: obj.ComplaintGroupAssociationId,
                            ComplaintGroupChildAssociationId: obj.ComplaintGroupChildAssociationId,
                            Value: obj.SystemName === 'CustomerVoiceToJobItem' ? "1" : "2",
                            Comments: (_obj$Comments = obj.Comments) !== null && _obj$Comments !== void 0 ? _obj$Comments : "",
                            ComplaintId: obj.ComplaintId,
                            ImageAttachments: ImageAttachmentsArray,
                            ComplaintAssociations: ComplaintAssociations
                        };
                    });
                    if ((_getCustomerVoiceSect = getCustomerVoiceSectionAttributes(customerVoiceSectionDetails)) !== null && _getCustomerVoiceSect !== void 0 && (_getCustomerVoiceSect = _getCustomerVoiceSect.SA_COMMENTS_SECTION_ATTRIBUTES) !== null && _getCustomerVoiceSect !== void 0 && _getCustomerVoiceSect.MANDATORY) {
                        checkComment = transformedArray_1.every(function (item) { return item.Comments; });
                        if (!checkComment) {
                            profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                            GoogleAnlyticsErrorLog(profileData, 'ClientSide', t('SA_COMMENTS_MANDATORY_ERROR'));
                            dispatch(showNotification({
                                isOpen: true,
                                message: t('SA_COMMENTS_MANDATORY_ERROR'),
                                type: "error"
                            }));
                            return [2 /*return*/];
                        }
                    }
                    updatedDeclinedJobItems = declinedComplaints.filter(function (item) { return !transformedArray_1.some(function (transformedItem) { return transformedItem.ComplaintId === item.ComplaintId; }); });
                    declinedRequestBodyArray_1 = [];
                    updatedDeclinedJobItems.map(function (declinedItem) {
                        declinedRequestBodyArray_1.push({
                            SystemName: declinedItem.SystemName,
                            ComplaintGroupAssociationId: declinedItem.ComplaintGroupAssociationId,
                            ComplaintGroupChildAssociationId: declinedItem.ComplaintGroupChildAssociationId,
                            ComplaintAssociations: [],
                            Comments: declinedItem.Comments,
                            ComplaintId: declinedItem.ComplaintId,
                            DeclinedJobReasonId: declinedItem.DeclinedJobReasonId,
                            Remarks: declinedItem.Remarks,
                            Value: declinedItem.Value,
                            ImageAttachments: declinedItem.ImageAttachments ? declinedItem.ImageAttachments : []
                        });
                    });
                    declinedRequestBody = {
                        PreJobCardDocumentId: parentModuleDocumentId,
                        InstallBaseId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById3 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById3 === void 0 ? void 0 : _ModuleDetailsGetById3.InstallBaseId,
                        DeclinedJobItems: declinedRequestBodyArray_1
                    };
                    request = _objectSpread(_objectSpread({}, apiRequestPayload), {}, {
                        "JobItems": transformedArray_1
                    });
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: "".concat(Config.baseURL).concat(apiRequestParam, "/UpsertCustomerVoiceToJobItem"),
                            request: request
                        }))];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: saveDeclinedCustomerComplaintsUrl,
                            request: declinedRequestBody
                        }))];
                case 3:
                    declinedResult = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 4:
                    _a.sent();
                    if (!(response !== null && response !== void 0 && (_response$payload2 = response.payload) !== null && _response$payload2 !== void 0 && (_response$payload2 = _response$payload2.value) !== null && _response$payload2 !== void 0 && _response$payload2.success || (response === null || response === void 0 || (_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.value) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.statusCode) == 200)) return [3 /*break*/, 6];
                    dispatch(setState({
                        key: "customerDetailsTrnalsteToJob",
                        value: {
                            success: true,
                            data: finalArray_1
                        }
                    }));
                    handleCloseTranslateToJoBitem();
                    dispatch(setState({
                        key: "getModuleHeaderCount",
                        value: _objectSpread(_objectSpread({}, getModuleHeaderCount), {}, {
                            jobItems: finalArray_1.length
                        })
                    }));
                    if (!(repeatAlertConfiguration !== null && repeatAlertConfiguration !== void 0 && (_repeatAlertConfigura = repeatAlertConfiguration.data) !== null && _repeatAlertConfigura !== void 0 && _repeatAlertConfigura.Transaction && Array.isArray(repeatAlertConfiguration === null || repeatAlertConfiguration === void 0 || (_repeatAlertConfigura2 = repeatAlertConfiguration.data) === null || _repeatAlertConfigura2 === void 0 ? void 0 : _repeatAlertConfigura2.Transaction) && repeatAlertConfiguration !== null && repeatAlertConfiguration !== void 0 && (_repeatAlertConfigura3 = repeatAlertConfiguration.data) !== null && _repeatAlertConfigura3 !== void 0 && _repeatAlertConfigura3.Transaction.includes(SystemName))) return [3 /*break*/, 6];
                    repeatBody = {
                        "InstallBaseId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById4 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById4 === void 0 ? void 0 : _ModuleDetailsGetById4.InstallBaseId,
                        "CurrentODOMeterReading": (_ModuleDetailsGetById5 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById5 === void 0 ? void 0 : _ModuleDetailsGetById5.ODOMeterReading,
                        "CurrentJobCardDate": moment().startOf('day'),
                        "CurrentJobCardParentOrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                        "CurrentJobCardOrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        "CurrentJobCardRepairTypeId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById6 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById6 === void 0 ? void 0 : _ModuleDetailsGetById6.RepairTypeId,
                        "ParentId": parentModuleDocumentId,
                        "CurrentComplaints": transformedArray_1.map(function (item) { return item.ComplaintId; }),
                        "CurrentParts": [],
                        "CurrentLabours": []
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            url: CheckRepeatUrl,
                            request: repeatBody
                        }))];
                case 5:
                    checkRepeatResponse = _a.sent();
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleMessageIcon = function () {
        setOpenSARemarkPopup(function (prev) { return !prev; });
    };
    return /*#__PURE__*/ React.createElement("div", null, isShowCapacitorMap ? /*#__PURE__*/ React.createElement(RoadTestNew, {
        timeDuration: timeDuration,
        coveredDistance: distance,
        isTestDone: isTestDone,
        pathCordinates: pathCordinates,
        onStartTest: handleStartRoadTest,
        onClickEndTest: handleEndRoadTest,
        onClickRoadTestTraslate: function (value) { return setTranslateToJobChecked(value); },
        onClickRoadTestVehicleDetails: function (value) { return setOpenViewJobs(value); },
        isviewOnly: isDisabled,
        onClickMsgIcon: handleMessageIcon,
        isDisabled: isDisabled
    }) : /*#__PURE__*/ React.createElement(RoadTest, {
        timeDuration: timeDuration,
        coveredDistance: distance,
        isTestDone: isTestDone,
        pathCordinates: pathCordinates,
        onStartTest: handleStartRoadTest,
        onClickEndTest: handleEndRoadTest,
        onClickRoadTestTraslate: function (value) { return setTranslateToJobChecked(value); },
        onClickRoadTestVehicleDetails: function (value) { return setOpenViewJobs(value); },
        isviewOnly: isDisabled,
        onClickMsgIcon: handleMessageIcon,
        isDisabled: isDisabled
    }), isTranslateToJobClicked && /*#__PURE__*/ React.createElement(TranslateToJobComponent, {
        isOpen: isTranslateToJobClicked,
        onClose: handleCloseTranslateToJoBitem,
        handleSave: function (listValue, declinedComplaints) { return handleSaveTrnalateToJob(listValue, declinedComplaints); },
        filterSystemName: "RoadTest",
        requestID: parentModuleDocumentId
    }), openViewJobs && /*#__PURE__*/ React.createElement(VehicleDetailsViewJobs, {
        customerVoiceId: customerVoiceId,
        isOpen: openViewJobs,
        onClose: handleCloseViewJobs,
        listItem: listValue,
        title: t('Job items'),
        requestID: parentModuleDocumentId
    }), openSARemarkPopup && /*#__PURE__*/ React.createElement(TranslateToJobMessage, {
        setIsOpen: function (value) { return setOpenSARemarkPopup(value); },
        isOpen: openSARemarkPopup,
        onClickMsgIcon: handleMessageIcon,
        data: "",
        handleDataBack: function (data) { return handleMessageIcon(); },
        isFromVehicleDetails: false,
        apiRequestParam: apiRequestParam,
        apiRequestPayload: apiRequestPayload,
        parentModuleDocumentId: parentModuleDocumentId,
        parentComponent: ESABoxParent.RoadTest,
        isViewOnly: isDisabled,
        RoadTestId: roadTestId,
        customerComplaintId: customerVoiceId
    }));
};
export default RoadTestComponent;
